export const competencePermissionsConst = {
  view: {
    value: "view_competence",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu kompetencji!",
  },
  add: {
    value: "add_competence",
    errorMsg: "Użytkownik nie ma uprawnień do dodania kompetencji!",
  },
  update: {
    value: "change_competence",
    errorMsg: "Użytkownik nie ma uprawnień do edycji kompetencji!",
  },
  delete: {
    value: "delete_competence",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania kompetencji!",
  },
};

export const holidayPermissionsConst = {
  view: {
    value: "view_holiday",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu dni wolnych!",
  },
  add: {
    value: "add_holiday",
    errorMsg: "Użytkownik nie ma uprawnień do dodania dni wolnych!",
  },
  update: {
    value: "change_holiday",
    errorMsg: "Użytkownik nie ma uprawnień do edycji dni wolnych!",
  },
  delete: {
    value: "delete_holiday",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania dni wolnych!",
  },
};

export const machinePermissionsConst = {
  view: {
    value: "view_machine",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu maszyn!",
  },
  add: {
    value: "add_machine",
    errorMsg: "Użytkownik nie ma uprawnień do dodania maszyn!",
  },
  update: {
    value: "change_machine",
    errorMsg: "Użytkownik nie ma uprawnień do edycji maszyn!",
  },
  delete: {
    value: "delete_machine",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania maszyn!",
  },
};

export const machineactionPermissionsConst = {
  view: {
    value: "view_machineaction",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu czynności maszyn!",
  },
  add: {
    value: "add_machineaction",
    errorMsg: "Użytkownik nie ma uprawnień do dodania czynności maszyn!",
  },
  update: {
    value: "change_machineaction",
    errorMsg: "Użytkownik nie ma uprawnień do edycji czynności maszyn!",
  },
  delete: {
    value: "delete_machineaction",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania czynności maszyn!",
  },
};

export const platePermissionsConst = {
  view: {
    value: "view_plate",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu płyt!",
  },
  add: {
    value: "add_plate",
    errorMsg: "Użytkownik nie ma uprawnień do dodania płyt!",
  },
  update: {
    value: "change_plate",
    errorMsg: "Użytkownik nie ma uprawnień do edycji płyt!",
  },
  delete: {
    value: "delete_plate",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania płyt!",
  },
};

export const appliancesPermissionsConst = {
  view: {
    value: "view_appliance",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu zastosowania!",
  },
  add: {
    value: "add_appliance",
    errorMsg: "Użytkownik nie ma uprawnień do dodania zastosowania!",
  },
  update: {
    value: "change_appliance",
    errorMsg: "Użytkownik nie ma uprawnień do edycji zastosowania!",
  },
  delete: {
    value: "delete_appliance",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania zastosowania!",
  },
};

// Units exist only in this panel - the old one has no unit management.
export const unitPermissionsConst = {
  view: {
    value: "view_unit",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu jednostek!",
  },
  add: {
    value: "add_unit",
    errorMsg: "Użytkownik nie ma uprawnień do dodania jednostek!",
  },
  update: {
    value: "change_unit",
    errorMsg: "Użytkownik nie ma uprawnień do edycji jednostek!",
  },
  delete: {
    value: "delete_unit",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania jednostek!",
  },
};

export const montagePermissionsConst = {
  view: {
    value: "view_montage",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu montażu!",
  },
  add: {
    value: "add_montage",
    errorMsg: "Użytkownik nie ma uprawnień do dodania montażu!",
  },
  update: {
    value: "change_montage",
    errorMsg: "Użytkownik nie ma uprawnień do edycji montażu!",
  },
  delete: {
    value: "delete_montage",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania montażu!",
  },
  set_closed_montage_permission: {
    value: "set_closed_montage_permission",
    errorMsg: "Użytkownik nie ma uprawnień do zamknięcia montażu!",
  },
  set_mounted_montage_permission: {
    value: "set_mounted_montage_permission",
    errorMsg: "Użytkownik nie ma uprawnień do zmontowania montażu!",
  },
  set_radiated_montage_permission: {
    value: "set_radiated_montage_permission",
    errorMsg: "Użytkownik nie ma uprawnień do naświetlania montażu!",
  },
  set_printed_montage_permission: {
    value: "set_printed_montage_permission",
    errorMsg: "Użytkownik nie ma uprawnień do wydrukowania montażu!",
  },
  view_montage_from_sites_permission: {
    value: "view_montage_from_sites_permission",
    errorMsg: "Użytkownik nie ma uprawnień do podglądu montażu!",
  },
};

export const orderProductProcessStageStatusPermissionsConst = {
  view: {
    value: "view_orderproductprocessstagestatus",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu statusów!",
  },
  add: {
    value: "add_orderproductprocessstagestatus",
    errorMsg: "Użytkownik nie ma uprawnień do dodania statusów!",
  },
};

// Maps the field names the backend reports errors under to the labels the
// machine form shows, so a nested error reads the way the form does. A machine
// is sent together with its actions and their costs in one request, which is
// why a message can arrive several levels deep.
export const machineErrorLabelsConst = {
  actions: "Czynność",
  costs: "Koszt stały",
  name: "Nazwa",
  model: "Model",
  type: "Typ",
  cost: "Koszt",
  amount: "Wartość",
  unit: "Typ",
  description: "Opis",
  sheets_per_hour: "Wydajność [arkusz/h]",
  checklist_before_start: "Checklista przed rozpoczęciem",
  checklist_before_end: "Checklista przed zakończeniem",
  max_print_x: "Max format zadruku (x)",
  max_print_y: "Max format zadruku (y)",
  min_print_x: "Min format zadruku (x)",
  min_print_y: "Min format zadruku (y)",
  matrix_x: "Format matrycy (x)",
  matrix_y: "Format matrycy (y)",
  matrix_cost_per_m2: "Koszt matrycy [m2]",
  image: "Zdjęcie",
};
